import { useNavigate } from 'react-router-dom';
import { ModuleProperties } from '@/lib/core/types';
import { useApp } from '@/lib/core/providers/appProvider';
import {
  IconLinksElementModel,
  IconLinksPropertiesModel,
  IconLinkItemPropertiesModel,
} from '@/services/platform/api/model';
import { Icon } from '@/components/ui/icon';
import ModuleWrapper from '@/components/shared/module/wrapper';

export const IconLinks = (props: ModuleProperties) => {
  const navigate = useNavigate();
  const { memberTheme, user } = useApp();
  const content = props.content as IconLinksElementModel | undefined;
  const properties = content?.properties as IconLinksPropertiesModel | undefined;

  const hasActiveMembership = user?.hasActiveMembership ?? false;
  const items = properties?.iconLink?.items ?? [];

  return (
    <ModuleWrapper
      component={props}
      isFullWidth={false}
      classNames={{
        base: 'mx-4 mt-8',
        wrapper: 'py-0 lg:py-0',
        grid: 'grid-cols-1 lg:grid-cols-1 gap-0',
      }}
    >
      <div className="grid grid-cols-3 gap-x-2 gap-y-6">
        {items.map((item, index) => {
          const itemProps = item?.content?.properties as IconLinkItemPropertiesModel | undefined;
          const icon = itemProps?.icon ?? '';
          const link = itemProps?.link?.[0];
          const label = link?.title ?? '';
          const to = link?.route?.path ?? link?.url ?? '/';

          if (itemProps?.membersOnly && !hasActiveMembership) return null;

          return (
            <button
              key={index}
              className="flex flex-col items-center gap-2"
              onClick={() => navigate(to)}
              aria-label={label}
            >
              <div
                className="flex size-14 items-center justify-center rounded-full bg-white"
                style={{ boxShadow: '0px 2px 6px rgba(0,0,0,0.12)' }}
              >
                <Icon name={icon} width={24} height={24} style={{ color: memberTheme.iconColor }} />
              </div>
              <span
                className="font-inter text-center text-[10px] font-medium tracking-[0.5px] uppercase"
                style={{ color: memberTheme.iconColor }}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </ModuleWrapper>
  );
};
